import { tick } from 'svelte';

/** Svelte の更新と次の描画まで待つ（observability.md §6.1 の「表示するまで」）。 */
export async function afterPaint(): Promise<void> {
  await tick();
  await new Promise<void>((resolve) => {
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => resolve());
    else resolve();
  });
}
